import * as React from "react";
import {
  List, Datagrid, TextField, FunctionField, DeleteButton,
} from "react-admin";
import { Box } from "@mui/material";
import { InfoGrid } from "../../components/InfoGrid";
import { DocumentDownloadButton } from "../../components/DocumentDownloadButton";
import { FrDateField } from "../../components/FrDateField";
import { UserRefField } from "../../components/ui";

// DocumentDTO fields : id, name, documentTypeEnum, idPatient, idPro,
// createdDate, active, mimeType, ovhPath, patientFirstName, patientLastName,
// bookingDate, bookingTime.
// Backend : GET /documents/all (admin, paginé, sans filtre), téléchargement
// GET /documents/{id}/download-url, suppression DELETE /documents/{id}.
// Pas de GET /documents/{id} ni de PUT : pas de fiche ni d'édition — le
// détail s'affiche en dépliant la ligne. Documents d'un patient / pro :
// onglets « Documents » des fiches.

const Details = () => (
  <Box sx={{ p: 1 }}>
    <InfoGrid
      fields={[
        { label: "ID", source: "id", type: "mono" },
        { label: "Nom", source: "name" },
        { label: "Type", source: "documentTypeEnum" },
        { label: "MIME", source: "mimeType", type: "mono" },
        { label: "ID patient", source: "idPatient", type: "mono" },
        { label: "Patient", source: (r) => `${r?.patientFirstName || ""} ${r?.patientLastName || ""}`.trim() || null },
        { label: "ID pro", source: "idPro", type: "mono" },
        { label: "Actif", source: "active", type: "bool" },
        { label: "Clé de stockage", source: "ovhPath", type: "mono" },
        { label: "Date RDV", source: (r) => r?.bookingDate ? new Date(r.bookingDate).toLocaleDateString("fr-FR") : null },
        { label: "Heure RDV", source: "bookingTime" },
      ]}
    />
  </Box>
);

export default {
  list: () => (
    <List perPage={25}>
      <Datagrid rowClick="expand" expand={<Details />} bulkActionButtons={false}>
        <TextField source="name" label="Fichier" />
        <TextField source="documentTypeEnum" label="Type" />
        <TextField source="mimeType" label="Format" />
        <UserRefField source="idPatient" label="Patient" />
        <UserRefField source="idPro" label="Professionnel" />
        <FrDateField source="createdDate" label="Ajouté le" showTime />
        <FunctionField label="" render={(r) => <DocumentDownloadButton documentId={r?.id} />} />
        <DeleteButton mutationMode="pessimistic" />
      </Datagrid>
    </List>
  ),
};
